// extracted by mini-css-extract-plugin
export var box = "Copyright-module--box--ddbfe";
export var wrapper = "Copyright-module--wrapper--43dcc";
export var box_md = "Copyright-module--box_md--8316d";
export var box_xmd = "Copyright-module--box_xmd--c4512";
export var box_flex = "Copyright-module--box_flex--adac7";
export var box_lg = "Copyright-module--box_lg--16cb7";
export var box_sm = "Copyright-module--box_sm--ac133";
export var box_outer = "Copyright-module--box_outer--01c5b";
export var box_whiteBg = "Copyright-module--box_white-bg--34648";
export var box_noMarginBottom = "Copyright-module--box_no-margin-bottom--0a0b6";
export var box_noPadding = "Copyright-module--box_no-padding--26bae";
export var box_outerGray = "Copyright-module--box_outer-gray--fa459";
export var box_dark = "Copyright-module--box_dark--86100";
export var box_zIndex = "Copyright-module--box_z-index--04886";
export var box_zIndex6 = "Copyright-module--box_z-index-6--d1a19";
export var box_eventsWithLine = "Copyright-module--box_events-with-line--6bd49";
export var box_featuresAo = "Copyright-module--box_features-ao--c827f";
export var box_verticalPaddings = "Copyright-module--box_vertical-paddings--4dd3f";
export var clearP = "Copyright-module--clearP--4699e";
export var clearP_vc = "Copyright-module--clearP_vc--e29a6";
export var copyright = "Copyright-module--copyright--c084a";
export var icon = "Copyright-module--icon--0d818";
export var link = "Copyright-module--link--80fb5";
export var textSection = "Copyright-module--textSection--0787a";
export var text = "Copyright-module--text--60a7c";
export var socialSection = "Copyright-module--socialSection--f9376";
export var usefullLink = "Copyright-module--usefullLink--4589a";
export var fadeInAnimation = "Copyright-module--fadeInAnimation--0a6ff";
export var placeHolderShimmer = "Copyright-module--placeHolderShimmer--70118";